import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Entry } from 'contentful';
import { Link } from '@/navigation';
import {
  TypeLink_externalFields,
  TypeLink_internal,
  TypeLink_internalFields,
} from '@/core/generated-types';
import { slugBuilder } from '@/core/contentfulConfig';
import { CONTENT_TYPE_LINK, getContentType } from '@/core/constants';

export type TypeLinkWrapperProps = {
  link?: Entry<TypeLink_externalFields | TypeLink_internalFields>;
  classes?: string;
  children?: ReactNode;
  onClick?: React.MouseEventHandler<any> | undefined;
};

type StyleWrapperProps = {
  children?: ReactNode;
  classes?: string | undefined;
};

const StyleWrapper: FC<StyleWrapperProps> = ({ children, classes }) => (
  <div className={classNames(classes)}>{children}</div>
);

const MaybeLinkToPDPWrapper: FC<TypeLinkWrapperProps> = ({
  link,
  classes,
  children,
  onClick,
}) => {
  if (!link) {
    return <StyleWrapper classes={classes}>{children}</StyleWrapper>;
  }

  if (getContentType(link) === CONTENT_TYPE_LINK.EXTERNAL) {
    return <StyleWrapper>{children}</StyleWrapper>;
  }

  const internalLink = link as TypeLink_internal;

  return (
    <StyleWrapper classes={classes}>
      <Link
        href={slugBuilder(internalLink)}
        data-testid="link-wrapper"
        onClick={onClick}
      >
        {children}
      </Link>
    </StyleWrapper>
  );
};

export default React.memo(MaybeLinkToPDPWrapper);
